export default __webpack_public_path__ + "static/media/create_image.0a889910.png";